var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"150px"},attrs:{"src":require("@/assets/images/logo/DNA-logo.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }